export default __webpack_public_path__ + "static/media/gpsWireless_feature2.87f32279.svg";